<template>
  <v-dialog-old ref="dialog" id="networkNotFound" @hidden="clearHash()">
    <div class="error-content">
      <h2><i class="fa fa-warning text-red"></i>Сеть клиник не найдена</h2>
      <span>Причина: </span>
        <template v-if="status !== ''">
            <span v-if="status === 'deleted'">сеть клиник удалена.</span>
            <span v-else>сети клиник с таким url не существует.</span>
        </template>
    </div>
  </v-dialog-old>
</template>

<script>
export default {
  name: "NetworkNotFound",
    data: function () {
        return {
            status: ''
        };
    },
  methods: {
    show (status) {
        this.status = status;
        this.$refs.dialog.show();
    },
    clearHash() {
        window.location.hash = '';
    }
  }
}
</script>

<style lang="scss">
#networkNotFound {
  max-width: 50%;
}
</style>
